import React from 'react';
import { useSelector } from 'react-redux';
import { PageHeader } from '../../../../../global/components/layout/page-header';
import { useLockedPageState } from '../../../../../global/hooks/useLockedPageState';
import { LockedPageKeys } from '../../../../../global/models/locked-page-model';
import { TcsmEpiApiState, TcsmStates } from '../../../../../root/tcsm-model';

import { useCompensationSetting } from '../../../components/use-compensation-setting';
import { EmploymentState } from '../../employment/employment-model';
import { ScheduledHoursHistoryView } from './scheduled-hours-history-view';

export function ScheduledHoursHistory() {

	const employmentState = useSelector<TcsmStates, EmploymentState>(state => state.employmentState);

	const epiProps = useSelector<TcsmStates, TcsmEpiApiState>(state => state.epiProps);
	const settings = useCompensationSetting();

	const lockedState = useLockedPageState(LockedPageKeys.Compensation);

	return (
		<>
			<PageHeader
				headerText={settings.scheduledHoursHistoryTitle}
				description={settings.scheduledHoursHistoryDescription} />
			<ScheduledHoursHistoryView
				labelSettings={epiProps?.labelSettingState?.epiContent}
				compensationProps={epiProps?.compensationSettingsState?.epiContent}
				scheduledHours={employmentState?.currentEmployment?.scheduled_hours}
				editDisabled={lockedState.isLocked}
			/>

		</>
	);
}